import gql from 'graphql-tag';
import apolloClient from 'src/store/client';

import { getSingleProp } from 'src/utils/lib/graphql';

const QUERY = gql`
  mutation ExportDocumentVariations(
    $template: ExportDocumentTemplateEnum!
    $format: ExportDocumentFormatEnum!
    $variations: [DocumentVariationInput!]!
  ) {
    exportDocumentVariations(template: $template, format: $format, variations: $variations) {
      downloadUrl
    }
  }
`;

export const exportDocumentVariations = async ({ id, template, format, variations }) => {
  const params = {
    query: QUERY,
    variables: {
      id,
      template,
      format,
      variations,
    },
  };

  const result = await apolloClient.query(params);
  return getSingleProp(result.data);
};
